module.exports = __webpack_public_path__ + "static/img/cooperate.b56bd12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShopSelfPrinting/cooperate.png
// module id = 9hOb
// module chunks = 10